import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import InputGroup from '@src/components/AdvertisingCampaign/Form/InputGroup'
import InputLabel from '@iui-kit/components/InputLabel'
import { Formik } from '@src/types/BriefSearch/formikProps'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Social/fieldNames'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepTwo: React.FC<HOCProps> = props => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.network.step.two.title">
      <InputGroup indent="l">
        <InputLabel
          size="l"
          name={FIELD_NAMES.COMPANY_NAME}
          label="Brief.network.field.companyName.label"
          value={values[FIELD_NAMES.COMPANY_NAME]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.COMPANY_NAME] || !touched[FIELD_NAMES.COMPANY_NAME]}
          placeholder={formatMessage({ id: 'Brief.network.field.companyName.placeholder' })}
        />
        <InputLabel
          size="l"
          name={FIELD_NAMES.COMPANY_FACEBOOK}
          label="Brief.network.field.companyFacebook.label"
          value={values[FIELD_NAMES.COMPANY_FACEBOOK]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.COMPANY_FACEBOOK] || !touched[FIELD_NAMES.COMPANY_FACEBOOK]}
          placeholder={formatMessage({ id: 'Brief.network.field.companyFacebook.placeholder' })}
        />
        <InputLabel
          size="l"
          notRequired={true}
          name={FIELD_NAMES.COMPANY_POLICY}
          label="Brief.network.field.companyPolicy.label"
          value={values[FIELD_NAMES.COMPANY_POLICY]}
          onChange={handleChange}
          handleBlur={handleBlur}
          isValid={!errors[FIELD_NAMES.COMPANY_POLICY] || !touched[FIELD_NAMES.COMPANY_POLICY]}
          placeholder={formatMessage({ id: 'Brief.network.field.companyPolicy.placeholder' })}
        />
      </InputGroup>
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepTwo)
